import useChatRestClient from '@/Api/ChatRestClient';
import {useMutation} from '@tanstack/react-query';

export default function useRescheduleMentorCall(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const ChatRestClient = useChatRestClient();
  type MentorCallsResponse = {
    success: boolean;
    [key: string]: any;
  };

  const mutation = useMutation<MentorCallsResponse>(
    async payload => {
      const response = await ChatRestClient.put(
        'subscription/v1/mentor-call',
        payload,
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess && data?.success) {
          handleOnSuccess(data);
        } else if (handleOnError) {
          handleOnError(data);
        }
      },
      onError: (error: any) => {
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
